export const sxStyled = theme => ({
  linkItineraryModalContainer: {
    alignItems: 'center',
  },
  linkItineraryModal: {
    backgroundColor: '#E5E5E5',
    borderRadius: '8px',
    color: '#000000',
    fontWeight: 400,
    placeItems: 'center',
    maxWidth: '80%',
    display: 'flex',
    whiteSpace: 'nowrap',
    height: '50px',
    marginRight: '1.4rem',
    width: { xs: '100%', sm: 'auto' },
    paddingRight: { xs: '10px', sm: 'initial' },
    margin: { xs: '0', sm: 'initial' },
  },
  linkItineraryText: {
    paddingLeft: '8px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  closeSeeShareItineraryModalBotton: {
    width: '30%',
    backgroundColor: theme.primary,
    borderRadius: '8px',
    fontSize: '20px',
    fontWeight: '700',
    textAlign: 'center',
    color: theme.text1,
    '&:hover': {
      backgroundColor: theme.primary,
      color: theme.text1,
    },
  },
  itinerarySeeModalGrid: {
    fontFamily: 'Open Sans',
    letterSpacing: '0em',
    display: 'flex',
    flexDirection: 'column',
    color: 'black',
    fontSize: '18px',
    position: 'absolute',
    width: { xs: '95%', sm: '60%' },
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    padding: { xs: '1rem', sm: theme.spacing(4) },
  },
});
